import { isOutsideBusinessHours } from '@/features/service-vendors/utils';
import type { BusinessHoursDto } from '@/services/api/petseo.client.wrapper';
import type { ScheduleDayFormData } from '@/schemas/schedule.schema';

export { isBusinessHoursMissing } from '@/features/service-vendors/utils';

export const isScheduleOutsideBusinessHours = (days: ScheduleDayFormData[], businessHours: BusinessHoursDto[] | undefined): boolean => {
  return days.some((day) => day.blocks.some((block) => isOutsideBusinessHours(businessHours, day.dayOfWeek, block.startTime, block.endTime)));
};
